var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginateRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M31 15.9998C31 7.89966 24.4335 1.33317 16.3333 1.33317C8.23316 1.33317 1.66667 7.89966 1.66667 15.9998C1.66667 24.1 8.23316 30.6665 16.3333 30.6665C24.4335 30.6665 31 24.1 31 15.9998Z",
    stroke: "#49A942",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M14.4142 21.6665L19.7071 16.3736C20.0976 15.9831 20.0976 15.3499 19.7071 14.9594L14.4142 9.6665",
    stroke: "#49A942",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginateRight);
export default __webpack_public_path__ + "static/media/paginateRight.4fb1bf21e9fa866a5d285c2a7b437aa3.svg";
export { ForwardRef as ReactComponent };